import { decode, isBlurhashValid } from "blurhash";
import { useEffect, useRef } from "react";

/**
 * Paints a BlurHash onto a small canvas that stretches to its box. A hash
 * that does not validate paints nothing: `decode` throws on malformed input,
 * and a throw during render would swap the whole page for the router's error
 * element.
 */
export function BlurHashCanvas({
  hash,
  className,
}: {
  hash: string;
  className?: string;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !isBlurhashValid(hash).result) return;
    const pixels = decode(hash, 32, 32);
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.putImageData(
      new ImageData(new Uint8ClampedArray(pixels), 32, 32),
      0,
      0
    );
  }, [hash]);

  return (
    <canvas ref={canvasRef} width={32} height={32} className={className} />
  );
}
